import { useSelector } from 'react-redux';

import { formatNumberAndCents } from '@makemydeal/dr-common-utils';
import * as accessoriesSelectors from '@makemydeal/dr-dash-store/selectors/accessoriesSelectors';
import { DealTabs } from '@makemydeal/dr-shared-types';

import { ReadOnlyLinkRow } from '../../ReadOnlyLinkRow';

export const AccessoriesRow = () => {
    const totalAccessoriesAmount = useSelector(accessoriesSelectors.getAccessoriesTotalAmount);

    return (
        <ReadOnlyLinkRow
            rowKey="accessories"
            label="Accessories"
            value={formatNumberAndCents(totalAccessoriesAmount)}
            tab={DealTabs.ACCESSORIES}
        />
    );
};
